/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PriceFromJSON, PriceToJSON, } from './Price';
import { CommonBookingInfoViewBasketBookingItemsInnerSegmentFromJSON, CommonBookingInfoViewBasketBookingItemsInnerSegmentToJSON, } from './CommonBookingInfoViewBasketBookingItemsInnerSegment';
/**
 * @export
 */
export const CommonBookingInfoViewBasketBookingItemsInnerCategoryEnum = {
    AssistedRefund: 'assisted_refund',
    AxaInsurance: 'axa_insurance',
    Bags: 'bags',
    BookingItem: 'booking_item',
    BookingRestore: 'booking_restore',
    CarrierItineraryChange: 'carrier_itinerary_change',
    ExtrasOther: 'extras.other',
    ExtrasPassengerDetailsChange: 'extras.passenger_details_change',
    FareLock: 'fare_lock',
    FlightEvent: 'flight_event',
    Flights: 'flights',
    Guarantee: 'guarantee',
    HandlingFee: 'handling_fee',
    ItineraryChange: 'itinerary_change',
    Meals: 'meals',
    PassengerDetailsChange: 'passenger_details_change',
    PriceChange: 'price_change',
    PriorityBoarding: 'priority_boarding',
    Seating: 'seating',
    ServiceAllocatedSeating: 'service.allocated_seating',
    ServiceBaggage: 'service.baggage',
    ServiceInfant: 'service.infant',
    ServiceMealsOnBoard: 'service.meals_on_board',
    ServiceMusicalEquipment: 'service.musical_equipment',
    ServiceOther: 'service.other',
    ServicePackage: 'service_package',
    ServicePriorityBoarding: 'service.priority_boarding',
    ServiceSpecialAssistance: 'service.special_assistance',
    ServiceSportsEquipment: 'service.sports_equipment',
    ServiceTravellingWithPets: 'service.travelling_with_pets',
    ServiceUpgradeBaggage: 'service.upgrade_baggage',
    Subscription: 'subscription'
};
/**
 * Check if a given object implements the CommonBookingInfoViewBasketBookingItemsInner interface.
 */
export function instanceOfCommonBookingInfoViewBasketBookingItemsInner(value) {
    if (!('category' in value) || value['category'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    return true;
}
export function CommonBookingInfoViewBasketBookingItemsInnerFromJSON(json) {
    return CommonBookingInfoViewBasketBookingItemsInnerFromJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketBookingItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'category': json['category'],
        'price': PriceFromJSON(json['price']),
        'quantity': json['quantity'],
        'segment': json['segment'] == null ? undefined : CommonBookingInfoViewBasketBookingItemsInnerSegmentFromJSON(json['segment']),
    };
}
export function CommonBookingInfoViewBasketBookingItemsInnerToJSON(json) {
    return CommonBookingInfoViewBasketBookingItemsInnerToJSONTyped(json, false);
}
export function CommonBookingInfoViewBasketBookingItemsInnerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'category': value['category'],
        'price': PriceToJSON(value['price']),
        'quantity': value['quantity'],
        'segment': CommonBookingInfoViewBasketBookingItemsInnerSegmentToJSON(value['segment']),
    };
}
